/**
 * JavaScript Graphical User Interface
 * Defining GUI.Fx namespace
 *
 * @author S. [LinuZz] Ostapenko
 * @version 0.1
 * @namespace GUI
 */

GUI.Fx = {};